import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/arrow-left.svg';
import _imports_1 from '@/assets/icon/arrow-right.svg';

const _withScopeId = n => (_pushScopeId("data-v-c266a404"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Collections");

const _hoisted_2 = {
  class: "wrapper"
};
const _hoisted_3 = {
  class: "pagination-wrapper"
};
const _hoisted_4 = {
  class: "pagination-contain"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_collection_card = _resolveComponent("collection-card");

  const _component_Slide = _resolveComponent("Slide");

  const _component_Pagination = _resolveComponent("Pagination");

  const _component_Carousel = _resolveComponent("Carousel");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_Carousel, {
    settings: $setup.settings,
    breakpoints: $setup.breakpoints,
    ref: "carousel",
    modelValue: _ctx.currentSlide,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.currentSlide = $event)
  }, {
    addons: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      style: {
        "cursor": "pointer"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $options.prev && $options.prev(...args)),
      src: _imports_0
    }), _createVNode(_component_Pagination), _createElementVNode("img", {
      style: {
        "cursor": "pointer"
      },
      onClick: _cache[1] || (_cache[1] = (...args) => $options.next && $options.next(...args)),
      src: _imports_1
    })])])]),
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, slide => {
      return _createVNode(_component_Slide, {
        key: slide
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_collection_card, {
          product: $options.showcase[slide - 1],
          key: `showcase-${$options.showcase[slide - 1].name}`,
          onClick: $event => $options.goRoute($options.showcase[slide - 1]),
          class: "image-wrapper"
        }, null, 8, ["product", "onClick"]))]),
        _: 2
      }, 1024);
    }), 64))]),
    _: 1
  }, 8, ["settings", "breakpoints", "modelValue"])])], 64);
}